import { Link } from "react-router";
import { cn } from "@util/helpers";

import { FooterMenuLinksProps } from "./types";

/**
 * Component to render footer links for footer component in Events and Awards pages
 */
const FooterMenuLinks = ({
  items,
  className,
  linkClassName,
}: FooterMenuLinksProps): React.ReactElement => {
  return (
    <div
      className={cn("flex flex-col", className)}
      data-testid="footer-menu-links-component"
    >
      {items.map((item) => (
        <Link
          to={`${item.link}?ref=footer`}
          key={item.label}
          className={cn(
            "text-left text-base text-white hover:text-white/75",
            linkClassName
          )}
          reloadDocument
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
};

export default FooterMenuLinks;
